import { render, staticRenderFns } from "./CartInfoServiceCard.vue?vue&type=template&id=63227e77"
import script from "./CartInfoServiceCard.vue?vue&type=script&lang=js"
export * from "./CartInfoServiceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports